"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _translations = require("../../libs/translationsUtils/translations");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _common = require("@insided/shared/utils/common");

var _Analytics = _interopRequireDefault(require("../analytics/Analytics"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var eventTracker = function eventTracker() {
  _publish.default.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'solved topics',
    click_source: (0, _common.getCurrentPage)()
  });

  if ((0, _common.getCurrentPage)() === 'homepage') {
    _Analytics.default.send('Homepage', 'Widget clicked', {
      Type: 'Solved topics'
    });
  }
};

var widgetName = 'solved_topics';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-solved_topics';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string(),
  amount: _zod.z.number(),
  query: _zod.z.object({
    maxResults: _zod.z.number(),
    minReplies: _zod.z.number(),
    prefixIds: _zod.z.array(_zod.z.string()),
    sort: _zod.z.string(),
    sortOrder: _zod.z.string()
  })
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var SolvedTopics = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SolvedTopics, _Component);

  var _super = _createSuper(SolvedTopics);

  function SolvedTopics(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SolvedTopics);
    _this = _super.call(this, props);
    _this.state = {
      topics: []
    };
    return _this;
  }

  (0, _createClass2.default)(SolvedTopics, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get('/widget/solvedTopics', {
                  params: {
                    query: JSON.stringify(this.props.query)
                  }
                });

              case 2:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;
                this.setState({
                  topics: data
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var topics = this.state.topics;
      var config = this.props.config;
      var classNames = 'widget--solved-topics';
      if (!topics.length) return null;
      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: widgetName,
        config: config,
        className: classNames
      }, (0, _preact.h)("ul", {
        className: "list simple-topic-list",
        onClick: eventTracker
      }, topics.map(function (topic, i) {
        return (0, _preact.h)("li", {
          key: i,
          className: "simple-topic-list--item"
        }, (0, _preact.h)("h6", {
          className: "simple-topic-list--title"
        }, (0, _preact.h)("a", {
          className: "link link--topic",
          href: (0, _absoluteUrlRuntime.resolveUrl)(topic.url)
        }, topic.title), (0, _preact.h)("span", {
          className: (0, _classnames.default)('icon', 'icon--round', 'icon--checkmark', 'text--success', 'qa-icon-answered')
        })), (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(topic.lastPost.url),
          className: "text--meta"
        }, topic.numberOfReplies, " ", (0, _translations.t)('Forum', 'Reply', {
          value: topic.numberOfReplies.toString()
        })));
      })));
    }
  }]);
  return SolvedTopics;
}(_preact.Component);

exports.default = SolvedTopics;